import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';

const radius = 175;
const diameter = Math.round(Math.PI * radius * 2);
const getOffset = (val = 0) => Math.round((100 - Math.min(val, 100)) / 100 * diameter);

@observer
class AnimatedCircle extends React.Component {

  static defaultProps = {
    progress: 0,
    animate: true,
    animationDuration: '1s',
    showPercentage: true,
    showPercentageSymbol: true,
    progressColor: 'rgb(76, 154, 255)',
    bgColor: '#ecedf0',
    textColor: '#6b778c',
    size: '100',
    lineWidth: '25',
    percentSpacing: 10,
  };

  render() {
    const { progress, size, bgColor, progressColor, lineWidth, animate, animationDuration, roundedStroke, responsive, onAnimationEnd } = this.props;
    const strokeDashoffset = getOffset(progress);
    const transition = animate ? `stroke-dashoffset ${animationDuration} ease-out` : undefined;
    const strokeLinecap = roundedStroke ? 'round' : 'butt';
    const svgSize = responsive ? '100%' : size;
    const animationPlayState = animate ? 'running' : 'paused';

    return (
      <svg
        width={svgSize}
        height={svgSize}
        viewBox='-25 -25 400 400'
      >
        <circle
          stroke={bgColor}
          cx='175'
          cy='175'
          r='175'
          strokeWidth={lineWidth}
          fill='none'
        />
        <circle
          stroke={progressColor}
          transform='rotate(-90 175 175)'
          cx='175'
          cy='175'
          r='175'
          strokeDasharray='1100'
          strokeWidth={lineWidth}
          strokeDashoffset='1100'
          strokeLinecap={strokeLinecap}
          fill='none'
          style={{ strokeDashoffset, transition, animationPlayState }}
          onTransitionEnd={onAnimationEnd}
        />
      </svg>
    );
  }
}

export default ErrorBoundary(AnimatedCircle);
